<a href="{{link}}}" class="footer-icons footer-popup" data-popup="faculty">
  <i class="fa-thin {{icon}}" *ngIf="icon"></i><span>{{text}}</span>
</a>
